/* eslint-disable no-undef */
import { select } from "d3";
import Tooltip from "./Tooltip";

export const GTExHeatmapConfig = {
  useLog: false,
  logBase: null,
  width: 450,
  height: 800,
  marginL: 20,
  marginR: 10,
  marginT: 70,
  marginB: 70,
  colorScheme: "GnBu",
  cornerRadius: 15,
  columnLabelHeight: 10,
  columnLabelAngle: 60,
  columnLabelPosAdjust: 30,
  rowLabelWidth: 235,
  r: 4,
  legendName: "Median read count per base",
};

export const drawColorLegend = (
  title,
  dom,
  scale,
  config,
  ticks = 10,
  cell = { h: 10, w: 40 },
  orientation = "h",
  diverging = false
) => {
  let data = [];
  if (diverging) {
    const range = Array(ticks + 1)
      .fill(null)
      .map((u, i) => i);
    const interval = scale.domain()[1] / ticks;
    data = range.map((d) => d * interval);
    data = data
      .concat(range.filter((d) => d !== 0).map((d) => 0 - d * interval))
      .sort((a, b) => {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        if (a === b) {
          return 0;
        }
        return NaN;
      });
  } else {
    const range = Array(ticks + 1)
      .fill(null)
      .map((u, i) => i);
    const interval = scale.domain()[1] / ticks;
    data = range.map((d) => d * interval);
  }
  /* Legend groups. */
  const legends = dom
    .append("g")
    .attr("transform", `translate(${config.x}, ${config.y})`)
    .selectAll(".legend")
    .data(data);

  const g = legends.enter().append("g").classed("legend", true);

  if (orientation === "h") {
    /* Legend title. */
    dom
      .append("text")
      .attr("class", "color-legend")
      .text(title)
      .attr("x", -10)
      .attr("text-anchor", "end")
      .attr("y", cell.h)
      .attr("transform", `translate(${config.x}, ${config.y})`);

    /* Legend color. */
    g.append("rect")
      .attr("x", (d, i) => cell.w * i)
      .attr("y", 5)
      .attr("width", cell.w)
      .attr("height", cell.h)
      .style("fill", scale);

    g.append("text")
      .attr("class", "color-legend")
      .text((d) => d.toPrecision(2))
      .attr("x", (d, i) => cell.w * i)
      .attr("y", 0);
  } else {
    /* Legend title. */
    dom
      .append("text")
      .attr("class", "color-legend")
      .text(title)
      .attr("x", 5)
      .attr("text-anchor", "start")
      .attr("y", 0)
      .attr(
        "transform",
        `translate(${config.x}, ${config.y + cell.h * data.length})rotate(90)`
      );

    /* Legend color. */
    g.append("rect")
      .attr("x", 0)
      .attr("y", (d, i) => cell.h * i)
      .attr("width", cell.w)
      .attr("height", cell.h)
      .style("fill", scale);

    g.append("text")
      .attr("class", "color-legend")
      .text((d) => d.toPrecision(2))
      .attr("x", 15)
      .attr("y", (d, i) => cell.h * i + cell.h / 2);
  }
};

export const createSvg = (id, width, height, margin, svgId = undefined) => {
  let scalableVectorGraphicId;
  if (svgId === undefined) scalableVectorGraphicId = `${id}-svg`;
  return select(`#${id}`)
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .attr("id", scalableVectorGraphicId)
    .append("g")
    .attr("transform", `translate(${margin.left}, ${margin.top})`);
};

export const addTooltip = (id) => {
  const tooltipId = `tooltip_${id}`;
  if (!document.getElementById(tooltipId)) {
    const toolTip = document.createElement("div");
    toolTip.id = tooltipId;
    document.body.appendChild(toolTip);
  }
  const tooltip = new Tooltip(tooltipId);
  select(`#${tooltipId}`).classed("heatmap-tooltip", true);
  return tooltip;
};
